import type React from 'react';

import { Divider, Typography } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';
import { Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, withStyles } from '@material-ui/core';
import * as styles from './styles';

import { HintPopup } from '@cobliteam/base-components';

import Icon, { type IconNames } from '@cobliteam/ui/icons';

const Accordion = withStyles({
  root: {
    '&:before': {
      display: 'none',
    },
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    padding: '0',
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
  },
  content: {
    margin: 0,
    '&$content': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
  },
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0,
  },
})(MuiAccordionDetails);

export interface HintTitles {
  open: string;
  close: string;
}

export interface ExpansionCardIcons {
  open: IconNames;
  close: IconNames;
  className?: string;
}

export interface ExpansionCardProps {
  title: string | JSX.Element;
  isExpanded: boolean;
  children: React.ReactNode;
  hintTitles?: HintTitles;
  icons?: ExpansionCardIcons;
  className?: string;
  summaryClassName?: string;
  onChange: (expanded: boolean) => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const ExpansionCard = ({ title, isExpanded, children, hintTitles, icons, className, summaryClassName, onChange }: ExpansionCardProps) => {
  const handleOnChange = (_: React.ChangeEvent<{}>, expanded: boolean) => {
    onChange(expanded);
  };

  const OpenIcon = icons?.open || 'chevron-down';
  const CloseIcon = icons?.close || 'chevron-up';
  const iconClassName = icons?.className || styles.openCloseIcon;

  return (
    <Accordion square className={cn(className, styles.container)} expanded={isExpanded} onChange={handleOnChange}>
      <AccordionSummary className={cn(summaryClassName, styles.summary)}>
        <div className={styles.summaryHeader}>
          <Typography variant='heading-2'>{title}</Typography>
          <HintPopup enabled={Boolean(hintTitles)} arrow placement='top' title={isExpanded ? hintTitles?.close || '' : hintTitles?.open || ''}>
            <div>
              <Icon name={isExpanded ? CloseIcon : OpenIcon} />
            </div>
          </HintPopup>
        </div>
      </AccordionSummary>
      <Divider />
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default ExpansionCard;
